import * as React from 'react'

interface Props {
    items: string[]
}

const ItemArrayDisplay = ({ items }: Props): JSX.Element => {
    return (
        <>
            {items.map((item, index) => (
                <span key={Math.random()}>
                    <span>{item}</span>
                    {index !== items.length - 1 && <span style={{ fontWeight: 'normal' }}> or </span>}
                </span>
            ))}
        </>
    )
}

export default ItemArrayDisplay
